import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  LinearProgress,
  Typography,
  Box,
  CircularProgress
} from "@mui/material";

const ProgressModal = ({ open, isLoader, title = "Uploading...", progress = 0 }) => {
  return (
    <Dialog open={open} fullWidth maxWidth="sm">
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        {
          isLoader ?
            (<Box
              display="flex"
              flexDirection="column"
              alignItems="center"
              justifyContent="center"
              py={3}
            >
              <CircularProgress size={100} thickness={4}
                sx={{
                  color: "#FF9800", // Progress color
                  "& .MuiCircularProgress-circle": {
                    strokeLinecap: "round", // optional for smooth edges
                  }
                }} />
              <Typography variant="body2" sx={{ mt: 2 }}>
                Please wait...
              </Typography>
            </Box>) :
            (<Box display="flex" alignItems="center" gap={2} mt={1}>
              <Box flex={1}>
                <LinearProgress
                  variant="determinate"
                  value={progress}
                  sx={{
                    height: 10,
                    borderRadius: 5,
                    backgroundColor: "#f0f0f0", // Track color
                    "& .MuiLinearProgress-bar": {
                      backgroundColor: progress < 80 ? "#FF9800" : "#4CAF50",
                    }
                  }}
                />
              </Box>
              <Typography variant="body2" sx={{ minWidth: 40 }}>
                {`${Math.round(progress)}%`}
              </Typography>
            </Box>)
        }
      </DialogContent>
    </Dialog>
  );
};

export default ProgressModal;
